export const NO_SPECIAL_CHARACTERS_REGEX = /[^0-9A-Za-z\s.\-@$%()^#&*!;]/g;
export const SECTION_HEADER_NAME_MAX_LENGTH = 65;

/**
 * Create organization
 */
export const ORGANIZATION_DISCOVERY_OTHER_OPTION_MAX_LENGTH = 250;

/**
 * Rooms
 */
export const DOCUMENTS_LAZY_LOADING_MOBILE_THRESHOLD = 5;
export const DOCUMENTS_LAZY_LOADING_THRESHOLD = 10;
export const ROOM_CONTENT_DESCRIPTION_MAX_LENGTH = 1000;
export const ROOM_CONTENT_NAME_MAX_LENGTH = 255;
export const ROOM_DESCRIPTION_MAX_LENGTH = 255;
export const ROOM_NAME_MAX_LENGTH = 250;
export const ROOM_NOTIFICATIONS_GUESTS_LIMIT = 500;
export const DEFAULT_ROWS_PER_PAGE = 10;

/**
 * Contents
 */
export const CONTENT_NAME_MAX_LENGTH = 255;
export const EMBEDDABLE_CONTENT_MAX_LENGTH = 20000;
export const EMBEDDABLE_CONTENT_NAME_MAX_LENGTH = 255;
export const TEXT_CONTENT_MAX_LENGTH = 65500;
export const URL_CONTENT_NAME_MAX_LENGTH = 255;
export const URL_CONTENT_URL_MAX_LENGTH = 500;

/**
 * Insights
 */
export const INSIGHTS_CONTENT_NAME_MAX_LENGTH = 40;

/**
 * Inputs
 */
export const MAX_INTEGER = 2147483647;
export const SEARCH_DEBOUNCE_TIMEOUT = 500;
export const SEARCH_DEBOUNCE_TIMEOUT_SHORT = SEARCH_DEBOUNCE_TIMEOUT / 2;

/**
 * Signables
 */
export const SIGNABLE_NAME_MAX_LENGTH = 250;
export const SIGNABLE_VOID_REASON_MAX_LENGTH = 250;

/**
 * Owner Drop Downs
 */ export const USERS_FILTER_VISIBLE_AMOUNT = 5;
export const USERS_PAGINATION_LIMIT_FOR_INSIGHTS_OPTIMIZATION = 2500;
export const USERS_PAGINATION_MAX_AMOUNT = 50;
export const MAX_ROWS_TO_EXPORT = 1000000;

/**
 * Image load retries.
 * The formula is 1 + (1 * n) where n is the number of retries, for a total of
 * 24 retries in 5 minutes.
 */
export const IMAGE_LOAD_RETRIES = 24;

/**
 * Users
 */
export const USER_NAME_MAX_LENGTH = 255;
export const USER_JOB_TITLE_MAX_LENGTH = 255;
export const USER_LINKEDIN_MAX_LENGTH = 255;
export const USER_PHONE_MAX_LENGTH = 255;
export const USER_ROLE_MAX_LENGTH = 140;

/**
 * Room object acls
 */
export const ROOM_OBJECT_ACLS_LIMIT = 100;
